import React from "react";
import { Link } from "react-router-dom";
import { navLinks, socialLinks, Links } from "../Resource/data";
import Logo from "../Resource/images/logo.png";
import RoadmapPdf from "../Resource/roadmap.pdf";
import WhitepaperPdf from "../Resource/whitepaper.pdf";

const Footer = () => {
  const handleOpenPdf1 = () => {
    window.open(WhitepaperPdf, "_blank")
  };
   const handleOpenPdf2 = () => {
      window.open(RoadmapPdf, "_blank");
    };
  return (
    <div className="bg-primaryDark bg-opacity-70 px-6 py-6">
      <div className=" grid grid-cols-1 md:grid-cols-4 py-6 md:py-0 w-full mx-auto">
        {/* Logo */}
        <div className="flex items-center justify-center">
          <Link to="/">
            <img src={Logo} alt="logo" className="w-24" />
          </Link>
        </div>
        {/* Nav Links */}
        <div>
          <h1 className="text-xl font-bold border-b w-fit pb-2 my-3">
            Cronos Night Owls
          </h1>
          {navLinks.map((link) => (
            <Link to={link.path} key={link.name}>
              <h2 className="hover:text-primary w-fit">{link.name}</h2>
            </Link>
          ))}
        </div>
        {/* Social Links */}
        <div>
          <h1 className="text-xl font-bold border-b w-fit pb-2 my-3">
            Project info
          </h1>
          <div>
            <Link key="terms">
              <h2 className="hover:text-primary w-fit" onClick={handleOpenPdf2}>
                Roadmap
              </h2>
            </Link>
            <Link key="terms">
              <h2 className="hover:text-primary w-fit" onClick={handleOpenPdf1}>
                Whitepaper
              </h2>
            </Link>
          </div>
        </div>
        {/*  Links */}
        <div>
          <h1 className="text-xl font-bold border-b w-fit pb-2 my-3">
            Partner Links
          </h1>
          {Links.map((link) => (
            <Link to={link.path} target="_blank" key={link.name}>
              <h2 className="hover:text-primary w-fit">{link.name}</h2>
            </Link>
          ))}
        </div>
      </div>
      <div className="text-center py-4">&#169; Cronos Night Owls | Developed by <a target="_blank" rel="noreferrer" href="https://crosmolabs.com/">Crosmolabs</a> </div>
    </div>
  );
};

export default Footer;
